define.alias("shared/helpers/is-present", "settings/helpers/is-present");